import { createEntityParamsExpandColumn } from '@/components/entityParams/EntityParamsExpandedHeaders';
import type { DataTableHeader } from '@/types/vuetify';

export function createBookmakerPageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        createEntityParamsExpandColumn(),
        { title: t('bookmaker.code'), value: 'code', key: 'code', align: 'center', sortable: true, nowrap: true },
        { title: t('bookmaker.name'), value: 'name', key: 'name', align: 'center', sortable: true, nowrap: true },
        { title: t('bookmaker.url'), value: 'url', key: 'url', align: 'center', sortable: false, nowrap: true },
        { title: t('bookmaker.maintenance'), value: 'maintenance', key: 'maintenance', align: 'center', sortable: false, nowrap: true },
        { title: t('bookmaker.bettingError'), value: 'bettingError', key: 'bettingError', align: 'center', sortable: false, nowrap: true },
        { title: t('bookmaker.betting'), value: 'betting', key: 'betting', align: 'center', sortable: false, nowrap: true },
        { title: t('bookmaker.active'), value: 'active', key: 'active', align: 'center', sortable: false, nowrap: true },
        { title: '', value: 'infoMenu', key: 'infoMenu', align: 'end', sortable: false, nowrap: true, width: 24, cellProps: { class: 'pl-0 pr-1' } },
    ];
}
